// extracted by mini-css-extract-plugin
export default {"thread-override":"standard-info-thread-page_thread-override__3fucJ"};